import $ from 'jquery';
import CustomEvent from 'custom-event';

function getCustomerId() {
  return $('[data-customer-id]').data('customerId');
}

function dispatchWithUser(name) {
  const customerId = getCustomerId();

  const event = new CustomEvent(name, {
    bubbles: true,
    detail: {
      userId: customerId,
    },
  });

  document.body.dispatchEvent(event);
}

function handleRouteChange({detail = {}}) {
  const {type = '', currentRoute = ''} = detail;
  const $message = $('[data-posted-successfully]');
  const match = `${type}:${currentRoute}`;

  switch (match) {
    case 'login:account':
      dispatchWithUser('customerLogin');
      break;

    case 'register:register':
      if (!$message.length) {
        break;
      }

      dispatchWithUser('registration');
      break;

    case 'register:index':
      dispatchWithUser('registration');
      break;

    case 'addresses:addresses':
      dispatchWithUser('customerAddressChange');
      break;

    default:
      window.console.log('no match');
  }
}

$(document).on('routedetector:change', handleRouteChange);
